/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Preview_Property_PlaceholderInputs */

const cs_builder_preview_property_placeholder = /** @type {(inputs: Builder_Preview_Property_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukázková data`)
};

const en_builder_preview_property_placeholder = /** @type {(inputs: Builder_Preview_Property_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sample data`)
};

/**
* | output |
* | --- |
* | "Sample data" |
*
* @param {Builder_Preview_Property_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_preview_property_placeholder = /** @type {((inputs?: Builder_Preview_Property_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Preview_Property_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_preview_property_placeholder(inputs)
	return cs_builder_preview_property_placeholder(inputs)
});